// 使用role标记的元素标识，用在事件代理中，识别元素
export const ELEMENT_ROLE_SIGN = {
  errorAdvise: 'error-advise',
  fieldEmbed: 'field-embed',
  imgEmbed: 'img-embed',
};

export const FONT_DEF_COLOR = '#666666';
export const FONT_COLOR_CODE = [
  '#666666',
  '#BBBBBB',
  '#FF0100',
  '#FBBD00',
  '#03B050',
  '#0170C0',
  '#7031A0',
];

export const BG_COLOR_CODE = [
  '',
  '#D8D8D8',
  '#FFDCB6',
  '#FFF897',
  '#ABF361',
  '#CFDDFE',
  '#DCCAFC',
];

// 错误标签
export const ERROE_EMBED = {
  spell_error: 'SpellErrorEmbed',
  low_error: 'LowErrorEmbed',
  custom_error: 'CustomErrorEmbed',
};

// 纯前端的功能标记
export const FAKE_EMBED = {
  find_replace: 'FindReplaceEmbed',
}

// 标记
export const DIGIT_EMBED = {
  img: 'DotImgEmbed',
  field: 'DotFieldEmbed',
};

// 最大展示建议条数
export const MAX_SUGGESTS_COUNT = 5;

export const NO_COORD_ERROR_TYPES = ['miss_error', 'grammar_error'];
export const NO_COORD_ERROR_NAME = {
  miss_error: '漏译',
  grammar_error: '语法错误',
};
export const NO_PROMPT_TYPES = ['grammar_error'];